import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

export interface HistorialContractual {
  id?: number;
  placa: string;
  aseguradoraRCC: string;
  intermediariaRCC: string;
  fecha_expedicionRCC: string;
  fecha_vencimientoRCC: string;
  numeroRCC: string;
  estado?: number;
}

@Injectable({
  providedIn: 'root'
})
export class HistorialContractualService {
  private apiUrl =  `${environment.apiUrl}/api/historial_contractual`; 
  private apiUrl2 =  `${environment.apiUrl}/api/historial_contractual/renovar`; 


  constructor(private http: HttpClient, private authService: AuthService) {}

  getAll(): Observable<{ historial: HistorialContractual[] }> {
    return this.http.get<{ historial: HistorialContractual[] }>(this.apiUrl);
  }

  getById(id: number): Observable<HistorialContractual> {
    return this.http.get<HistorialContractual>(`${this.apiUrl}/${id}`);
  }

  create(data: HistorialContractual): Observable<HistorialContractual> {
    return this.http.post<HistorialContractual>(this.apiUrl, data);
  }

  update(id: number, data: HistorialContractual): Observable<HistorialContractual> {
    return this.http.put<HistorialContractual>(`${this.apiUrl}/${id}`, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  inactivarPorId(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/inactivar/${id}`, {});
  }

  renovarHistorialesContractuales(
    fechaExpedicionRCC: string,
    fechaVencimientoRCC: string,
    aseguradoraRCC?: string,
    numeroRCC?: string
  ): Observable<any> {
    const body: any = {
      fecha_expedicionRCC: fechaExpedicionRCC,
      fecha_vencimientoRCC: fechaVencimientoRCC
    };

    if (aseguradoraRCC) {
      body.aseguradoraRCC = aseguradoraRCC;
    }

    if (numeroRCC) {
      body.numeroRCC = numeroRCC;
    }

    return this.http.post<any>(this.apiUrl2, body);
  }

  getByPlaca(placa: string): Observable<HistorialContractual[]> {
    return this.http.get<HistorialContractual[]>(`${this.apiUrl}/placa/${placa}`);
  }
}
